module.exports = __webpack_public_path__ + "media/site_templates/www.localcarpenters.net.au/images/splash-2a23adc8cd9bab5e94753cbd78e90b4f.jpeg";